/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/apps', //:type/:uuid
          name: 'apps',
          component: () => import('./views/pages/Apps/List.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Apps', url: '/apps' },
              { title: 'Lista de Aplicaciones', active: true}
            ],
            pageTitle: 'Lista de Aplicaciones'
          }
        },
        {
          path: '/apps/add',
          name: 'apps-add',
          component: () => import('./views/pages/Apps/Add.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Apps', url: '/apps' },
              { title: 'Agregar Aplicación', active: true}
            ],
            pageTitle: 'Agregar Aplicación'
          }
        },
        {
          path: '/apps/:uuid',
          name: 'apps-detail',
          component: () => import('./views/pages/Apps/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Apps', url: '/apps' },
              { title: 'Detalle', active: true}
            ],
            pageTitle: 'Detalle de Aplicación'
          }
        },
        {
          path: '/apps/:uuid/update',
          name: 'apps-update',
          component: () => import('./views/pages/Apps/Update.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Apps', url: '/apps' },
              { title: 'Editar', active: true}
            ],
            pageTitle: 'Editar Aplicación'
          }
        },
        {
          path: '/licenses',
          name: 'licenses',
          component: () => import('./views/pages/Licenses/List.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Licencias', url: '/licenses' },
              { title: 'Lista de Licencias', active: true}
            ],
            pageTitle: 'Lista de Licencias'
          }
        },
        {
          path: '/licenses/add',
          name: 'licenses-add',
          component: () => import('./views/pages/Licenses/Add.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Licencias', url: '/licenses' },
              { title: 'Agregar', active: true}
            ],
            pageTitle: 'Agregar Licencia'
          }
        },
        {
          path: '/licenses/:uuid',
          name: 'licenses-detail',
          component: () => import('./views/pages/Licenses/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Licencias', url: '/licenses' },
              { title: 'Detalle', active: true}
            ],
            pageTitle: 'Detalle de Licencia'
          }
        },
        {
          path: '/licenses/:uuid/update',
          name: 'licenses-update',
          component: () => import('./views/pages/Licenses/Update.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Licencias', url: '/licenses' },
              { title: 'Editar Licencia', active: true}
            ],
            pageTitle: 'Editar Licencia'
          }
        },
        {
          path: '/licenses/:uuid/report',
          name: 'licenses-report',
          component: () => import('./views/pages/Licenses/Report.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Licencias', url: '/licenses' },
              { title: 'Reporte', active: true}
            ],
            pageTitle: 'Reporte'
          }
        },
        {
          path: '/licenses/:uuid/assign',
          name: 'licenses-assign',
          component: () => import('./views/pages/Licenses/Assign.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Licencias', url: '/licenses' },
              { title: 'Asignar Dispositivos', active: true}
            ],
            pageTitle: 'Asignar Dispositivos'
          }
        },
        {
          path: '/apps/:appid/devices',
          name: 'devices-list',
          component: () => import('./views/pages/Devices/List.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Apps', url: '/apps' },
              { title: 'Lista de Dispositivos', active: true}
            ],
            pageTitle: 'Lista de Dispositivos'
          }
        },
        {
          path: '/devices',
          name: 'devices',
          component: () => import('./views/pages/Devices/List.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Dispositivos', url: '/devices' },
              { title: 'Lista de Dispositivos', active: true}
            ],
            pageTitle: 'Lista de Dispositivos'
          }
        },
        {
          path: '/devices/:uuid',
          name: 'device-detail',
          component: () => import('./views/pages/Devices/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Dispositivos', url: '/devices' },
              { title: 'Detalle del dispositivo', active: true}
            ],
            pageTitle: 'Detalle del dispositivo'
          }
        },
        {
          path: '/devices/:uuid/update',
          name: 'device-update',
          component: () => import('./views/pages/Devices/Update.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Devices', url: '/devices' },
              { title: 'Editar dispositivo', active: true}
            ],
            pageTitle: 'Editar dispositivo'
          }
        },
        {
          path: '/organizations',
          name: 'organizations-list',
          component: () => import('./views/pages/Organizations/List.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Compañías', url: '/organizations' },
              { title: 'Lista de Compañías', active: true}
            ],
            pageTitle: 'Lista de Compañías'
          }
        },
        {
          path: '/organizations/add',
          name: 'organizations-add',
          component: () => import('./views/pages/Organizations/Add.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Compañías', url: '/organizations' },
              { title: 'Agregar Compañía', active: true}
            ],
            pageTitle: 'Agregar Compañía'
          }
        },
        {
          path: '/organizations/:uuid',
          name: 'organizations-detail',
          component: () => import('./views/pages/Organizations/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Compañías', url: '/organizations' },
              { title: 'Detalle de la Compañía', active: true}
            ],
            pageTitle: 'Detalle de la Compañía'
          }
        },
        {
          path: '/organizations/:uuid/update',
          name: 'organizations-update',
          component: () => import('./views/pages/Organizations/Update.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Compañías', url: '/organizations' },
              { title: 'Editar Compañía', active: true}
            ],
            pageTitle: 'Editar Compañía'
          }
        },
        {
          path: '/profiles',
          name: 'profiles',
          component: () => import('./views/pages/DeviceProfiles/List.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Perfiles', url: '/profiles' },
              { title: 'Perfiles', url: '/profiles' }
            ],
            pageTitle: 'Lista de Perfiles'
          }
        },
        {
          path: '/profiles/add',
          name: 'profiles-add',
          component: () => import('./views/pages/DeviceProfiles/Add.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Perfiles', url: '/profiles' },
              { title: 'Agregar Perfil', active: true}
            ],
            pageTitle: 'Agregar Perfil'
          }
        },
        {
          path: '/profiles/:uuid',
          name: 'profiles-detail',
          component: () => import('./views/pages/DeviceProfiles/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Perfiles', url: '/profiles' },
              { title: 'Detalle Perfil', active: true}
            ],
            pageTitle: 'Detalle Perfil'
          }
        },
        {
          path: '/profiles/:uuid/update',
          name: 'profiles-update',
          component: () => import('./views/pages/DeviceProfiles/Update.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Perfiles', url: '/profiles' },
              { title: 'Editar Perfil', active: true}
            ],
            pageTitle: 'Editar Perfil'
          }
        },
        {
          path: '/types',
          name: 'types',
          component: () => import('./views/pages/DeviceTypes/List.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Tipos de dispositivo', url: '/types' },
              { title: 'Tipos', url: '/types' }
            ],
            pageTitle: 'Lista de tipos de dispositivos'
          }
        },
        {
          path: '/types/add',
          name: 'types-add',
          component: () => import('./views/pages/DeviceTypes/Add.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Tipos de dispositivos', url: '/types' },
              { title: 'Agregar Tipo', active: true}
            ],
            pageTitle: 'Agregar Tipo'
          }
        },
        {
          path: '/types/:uuid',
          name: 'types-detail',
          component: () => import('./views/pages/DeviceTypes/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Tipos de dispositivo', url: '/types' },
              { title: 'Detalle Tipo', active: true}
            ],
            pageTitle: 'Detalle Tipo'
          }
        },
        {
          path: '/types/:uuid/update',
          name: 'types-update',
          component: () => import('./views/pages/DeviceTypes/Update.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/apps' },
              { title: 'Tipos de dispositivo', url: '/types' },
              { title: 'Editar Tipo', active: true}
            ],
            pageTitle: 'Editar Tipo'
          }
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/pages/Dashboard/Dashboard.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/dashboard' }],
            pageTitle: 'Dashboard'
          }
        }
      ]
    },
    
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

/*router.beforeEach((to, from, next) => {
    if (store.state.AppActiveUser.token.length > 0) {
        if(to.path == '/' || to.path == '/forgot-password' || (store.state.AppActiveUser.userRole != 'MA' && to.matched.some(record => record.meta.rule == 'admin'))){
          window.location.href = "/apps-menu/apps";
        }else{
          next()
        }
    }
    else{
      if(to.path == '/' || to.path == '/forgot-password'){
        next()
      }
      else{
        window.location.href = "/";
      }
    }

})*/

export default router
